import axios from '../utils/axios';

export const getCharityDonations = ({ from_date, to_date }) =>
  axios.get('reports/charity-donations', {
    params: {
      from_date,
      to_date,
    },
  });
